/**
 * Catalog settings API client (BFF: `/api/v1/store/settings/catalog`).
 */
import { apiClient } from '@/shared/api';
import type { CatalogSettings, UpdateCatalogSettingsRequest } from '../model/settingsTypes';

const BASE = '/api/v1/store/settings/catalog';

export const getCatalogSettings = async (): Promise<CatalogSettings> =>
  (await apiClient.get<CatalogSettings>(BASE)).data;

export const updateCatalogSettings = async (
  body: UpdateCatalogSettingsRequest,
): Promise<CatalogSettings> => (await apiClient.put<CatalogSettings>(BASE, body)).data;
